import React from 'react';
import { StyleSheet, View } from 'react-native';

import formatDate from '../../core/support/formatDate';
import { Checkbox, Td, Tr } from '../../core-ui';
import { PaymentLineItem as PaymentLineItemType } from '../../types/shared/Vendor';

import { dateCellStyle, IsSelected, ToggleSelection } from './LineItem';
import formatCurrency from '../../core/support/formatCurrency';

type Props = {
  allowSelection?: boolean;
  currency: string;
  isSelected: IsSelected;
  lineItem: PaymentLineItemType;
  toggleSelection: ToggleSelection;
};

export function PaymentLineItem(props: Props) {
  const { allowSelection, currency, lineItem } = props;
  return (
    <Tr>
      {allowSelection ? <Td /> : null}
      <Td style={dateCellStyle}>{formatDate(lineItem.created_at)}</Td>
      <Td>
        {lineItem.provider}
        {lineItem.note && `: ${lineItem.note}`}
      </Td>
      <Td style={{ textAlign: 'end', whiteSpace: 'nowrap' }}>
        -{formatCurrency(lineItem.amount, currency)}
      </Td>
    </Tr>
  );
}

export function renderCheckbox(input: {
  lineItem: PaymentLineItemType;
  isSelected: (lineItem: PaymentLineItemType) => boolean;
  toggleSelection: (lineItem: PaymentLineItemType) => void;
}) {
  const { lineItem, isSelected, toggleSelection } = input;
  return (
    <View style={styles.checkboxContainer}>
      <Checkbox
        isChecked={isSelected(lineItem)}
        onChange={() => {
          toggleSelection(lineItem);
        }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  checkboxContainer: {
    ...StyleSheet.absoluteFillObject,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
